// routes/generator.image.$tab.tsx
import { match } from 'ts-pattern'
import { ALLOWED_GENERATOR_TABS } from 'src/components/GenerationTask/MultiColumnGenerationForm/constants'
import { getI18n } from 'src/i18n/i18n.middleware'
import { createRedirect } from 'src/utils/router/route'
import { dynamic } from 'src/utils/ssr'
import { staticMeta, staticMetaLoader } from 'src/utils/ssr-meta/seo'
import type { Route } from './+types/generator.image.$tab'

const getClientModule = () => import('src/clientRoutes/generator.image.$tab')

export const handle = {
  name: 'generator/image/:tab',
  track: ({ params }: { params: { tab?: string } }) => ({
    scene: match(params.tab)
      .with('editor', () => 'generator-edit')
      .with('animation', () => 'generator-animation')
      .with('enhancement', () => 'generator-enhance')
      .otherwise(() => undefined),
  }),
  hideMembershipBanner: true,
}

export function loader({ request, context }: Route.LoaderArgs) {
  const { t } = getI18n(context)
  return staticMetaLoader({
    requestUrl: request.url,
    title: t('server:meta.home.title'),
  })
}

export function meta({ loaderData }: Route.MetaArgs) {
  return staticMeta(loaderData)
}

export async function clientLoader({
  request,
  params,
  serverLoader,
}: Route.ClientLoaderArgs) {
  if (params.tab && !ALLOWED_GENERATOR_TABS.includes(params.tab)) {
    throw createRedirect(request, '/generator/image')
  }
  return serverLoader?.()
}
clientLoader.hydrate = true

export default dynamic(getClientModule, { ssr: false })
